import Swiper, {Navigation, Pagination, EffectFade} from "swiper";

export default class SliderContactMap {
  constructor() {
    if (!document.querySelector('.contacts-map__slider')) return false

    this.swiper = new Swiper('.contacts-map__slider', {

      modules: [Pagination, Navigation, EffectFade],

      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },

      spaceBetween: 32,

      navigation: {
        nextEl: '.contacts-map__slider .swiper-navigation-button-next',
        prevEl: '.contacts-map__slider .swiper-navigation-button-prev'
      },

      pagination: {
        el: '.contacts-map__slider .swiper-pagination',
        clickable: true
      }
    })
  }
}
